import * as actionTypes from "./../actions/ActionTypes"

const PLAYER_SONG = {
    isLoaded: false,
    parentId: null,
    id: null,
    type: null,
    cover: null,
    title: null,
    playlist: [],
    playlistIndex: 0,
    nextSong: null,
    isAnalyzing: false,
};

export default (state = PLAYER_SONG, action) => {
    switch (action.type) {
        case actionTypes.SET_PLAYER_SONG:
            let playerSong = {
                isLoaded: true,
                parentId: action.payload.playerSong.parentId,
                id: action.payload.playerSong.id,
                intentional: !!action.payload.playerSong._intentional,
                apple_id: action.payload.playerSong.apple_id || null,
                isrc: action.payload.playerSong.isrc || null,
                album: action.payload.playerSong.album || null,
                album_apple_id: action.payload.playerSong.album_apple_id || null,
                year: action.payload.playerSong.year || null,
                genre: action.payload.playerSong.genre || null,
                bpm: action.payload.playerSong.bpm || null,
                song_key: action.payload.playerSong.song_key || null,
                is_live: !!action.payload.playerSong.is_live,
                is_remix: !!action.payload.playerSong.is_remix,
                type: action.payload.playerSong.type,
                cover: action.payload.playerSong.cover,
                title: action.payload.playerSong.artist + ' - ' + action.payload.playerSong.title,
                // Raw artist/title kept alongside the combined `title` so the redesigned
                // player can render them on separate lines (legacy code still reads `title`).
                artist: action.payload.playerSong.artist || null,
                songTitle: action.payload.playerSong.title || null,
                src: action.payload.playerSong.song_url || null,
                song_url: action.payload.playerSong.song_url || null,
                playlist: action.payload.playlist,
                playlistIndex: 0,
                nextSong: action.payload.playlist[0],
                isAnalyzing: false
            }

            return playerSong;
        case actionTypes.CLEAR_PLAYER_SONG:
            return {...PLAYER_SONG, playlist: []};
        case actionTypes.SET_PLAYER_QUEUE:
            return {...state, playlist: action.payload || []};
        case actionTypes.SET_NEXT_SONG:
            return {
                ...state,
                playlistIndex: state.playlistIndex++,
                nextSong: state.playlist[state.playlistIndex]
            };
        default:
            return state;
    }
};